import {
  SwipeableCard,
  SwipeableCardHeader,
  SwipeableCardTitleGroup,
  SwipeableButton,
  SwipeableCardContent,
  SwipeableCardTitle,
  SwipeableCardSubtitle,
  SwipeableCardActions
} from './swipeable-card';

export const SWIPEABLE_CARD_DIRECTIVES: any[] = [
  SwipeableCard,
  SwipeableCardHeader,
  SwipeableCardTitleGroup,
  SwipeableButton,
  SwipeableCardContent,
  SwipeableCardTitle,
  SwipeableCardSubtitle,
  SwipeableCardActions
];

